/* eslint-disable jsx-a11y/no-distracting-elements */
function Collection() {
  return (
    <section className="no_side_space" id="COLLECTION">
      <span className="section_title">Meet the Funkies</span>
      <span className="section_text">
        The price of each Funky NFT Collectible is 30 MATIC, they are
        distributed on the Polygon Network, and there is a total of 10,000
        Collectibles.
      </span>
      <br />
      <br />
      <br />
      <marquee behavior="scroll" direction="right" scrollamount="15">
        <img src="img/m7.svg" alt="" />
        <img src="img/m8.svg" alt="" />
        <img src="img/m9.svg" alt="" />
        <img src="img/m10.svg" alt="" />
      </marquee>
    </section>
  );
}

export default Collection;
